"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLawFirmUser = exports.getUser = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const api_1 = require("../../services/api");
const preloaderSlice_1 = require("./preloaderSlice");
const lawFirmProfileSlice_1 = require("./lawFirmProfileSlice");
const initialState = {
    user: {
        id: 0,
        activated: 0,
        activation_date: '',
        att_range_value: '',
        attorney_registered: '',
        attorneys_range: 0,
        bio: '',
        contact_person: '',
        additional_phone: '',
        deleted: null,
        email: '',
        firm_name: '',
        full_address: {
            city: null,
            state_id: null,
            street: null,
            stringified: null,
            zip_code: null,
            state_abbrev: null
        },
        imageUrl: '',
        isLawFirm: null,
        name: '',
        submitted_requests: 0,
        website: '',
        areas: []
    },
    userLoaded: false,
};
const lawFirmSlice = toolkit_1.createSlice({
    name: 'lawFirm',
    initialState: initialState,
    reducers: {
        getUser: (state, action) => {
            state.user = action.payload;
            state.userLoaded = true;
            return state;
        }
    }
});
exports.getUser = lawFirmSlice.actions.getUser;
const getLawFirmUser = (id) => async (dispatch, getState) => {
    const userLoaded = getState().lawFirm.userLoaded;
    !userLoaded && dispatch(preloaderSlice_1.showLoader());
    try {
        const user = await api_1.LawFirm.getUser(id);
        const states = getState().staticData.states;
        const userState = states.filter(el => el.id === user.full_address.state_id)[0];
        user.full_address.state_abbrev = userState === null || userState === void 0 ? void 0 : userState.abbreviation;
        dispatch(exports.getUser(user));
        dispatch(lawFirmProfileSlice_1.setPracticeAreas(user));
        dispatch(preloaderSlice_1.hideLoader());
    }
    catch (e) {
        console.log(e);
    }
};
exports.getLawFirmUser = getLawFirmUser;
exports.default = lawFirmSlice.reducer;
